<template>
  <v-app id="inspire">
    <nav-bar />
    <v-main>
      <v-container
        fluid
        class="my-container pa-1 pt-2 flex-column elevation-0"
        style="flex: 1; display: flex; height: 100%"
      >
        <div
          class="ma-4 d-flex align-center justify-space-between"
          v-if="pageTitle && pageTitle !== $t('systemName')"
        >
          <h1 class="screen-title">{{ pageTitle }}</h1>
          <div class="text-right" v-if="backScreen && backScreen !== 'none'">
            <v-btn
              id="buttonBackHeader"
              class="btn-primary white--text"
              color="#2196F3"
              depressed
              height="40"
              min-width="120"
              @click="back"
            >
              <v-icon dense>{{ $t("ic.arrowLeft") }}</v-icon>
              <p class="ma-0 d-none d-xs-flex d-sm-flex">
                {{ btnBackText }}
              </p>
            </v-btn>
          </div>
        </div>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import store from "@/store";
import NavBar from "@/layout/NavBar";
import { mapGetters } from "vuex";
import JwtService from "@/common/jwt.service.js";
import { SCREEN } from "@/common/auth.const";
import { CONNECT_WS, DISCONNECT_WS } from "@/store/actions.type";

export default {
  name: "LayoutDefault",
  components: { NavBar },
  computed: {
    ...mapGetters([
      "pageTitle",
      "backScreen",
      "btnBackText",
      "query",
      "onClick",
    ]),
  },
  data() {
    return {
      fn: null,
      showProfile: false,
    };
  },
  methods: {
    async connectWs() {
      await store.dispatch(CONNECT_WS);
    },
    async disconnectWs() {
      await store.dispatch(DISCONNECT_WS);
    },
    closeDialogProfile: function () {
      this.showProfile = false;
    },
    back() {
      if (this.onClick) this.onClick();
      else {
        if (this.$route.query.return_url) {
          this.$router.push(this.$route.query.return_url + "");
          return;
        }

        // handel period back
        if (this.$route.params !== null && this.$route.params !== undefined) {
          if (
            this.$route.params.searchQueryPeriod !== null &&
            this.$route.params.searchQueryPeriod !== undefined
          ) {
            this.$router.push({
              name: this.backScreen,
              params: {
                searchQueryPeriod: this.$route.params.searchQueryPeriod,
              },
            });
            return;
          }
        }

        this.$router.push({
          name: this.backScreen,
          query: this.query,
        });
      }
    },
  },
  beforeMount() {
    // this.fn = setInterval(() => {
    //   if (JwtService.getToken() == null || JwtService.getToken() === "") {
    //     window.location = SCREEN.LOGIN.PATH;
    //   }
    // }, 1000);
  },
  async mounted() {
    await this.connectWs();
  },
  async beforeDestroy() {
    await this.disconnectWs();
    clearInterval(this.fn);
  },
};
</script>

<style lang="scss" scoped>
.my-container {
  background-color: #fff;
  min-width: 1000px;
}
.screen-title {
  color: #333;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 5px;
}
#inspire {
  height: 100vh;
  overflow: auto;
}
</style>
